<gl-pro-modal (closeModal)="close('close')">
  <p>{{ 'outdated_changes' | translate}}
  </p>
  <div class="buttons center">
    <button outline-button (click)="yes()">{{ 'yes' | translate }}</button>
    <button outline-button (click)="no()">{{ 'no' | translate }}</button>
  </div>
</gl-pro-modal>
